var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGmaps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFD8DC"
    },
    d: "M480.001,192v266.667c0.076,10.496-3.05,20.766-8.96,29.44c-1.898,3.003-4.116,5.793-6.613,8.32 L252.801,284.8l-7.467-7.467l145.707-145.707l9.173,5.76l74.667,45.44C478.058,184.795,479.994,188.263,480.001,192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CAF50"
    },
    d: "M391.041,131.627L237.868,284.8L26.241,496.427c-2.498-2.527-4.715-5.317-6.613-8.32 c-5.91-8.674-9.036-18.944-8.96-29.44V117.333C10.668,87.878,34.546,64,64.001,64h213.333c1.939,0.066,3.837,0.577,5.547,1.493 l98.987,60.373L391.041,131.627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2196F3"
    },
    d: "M464.428,496.427c-2.526,2.499-5.315,4.717-8.32,6.613c-8.674,5.911-18.944,9.037-29.44,8.96H64.001 c-10.496,0.077-20.766-3.049-29.44-8.96c-3.005-1.897-5.794-4.114-8.32-6.613L237.868,284.8l7.467-7.467l7.467,7.467 L464.428,496.427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M471.041,488.107c-3.775,6.05-8.883,11.158-14.933,14.933L237.868,284.8 c-4.082-4.165-4.014-10.851,0.151-14.933c4.106-4.024,10.676-4.024,14.782,0L471.041,488.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC107"
    },
    d: "M400.215,137.387L252.801,284.8L34.561,503.04c-6.05-3.775-11.158-8.883-14.933-14.933l362.24-362.24 L400.215,137.387z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M106.668,192c-23.564,0-42.667-19.103-42.667-42.667s19.103-42.667,42.667-42.667 s42.667,19.103,42.667,42.667S130.232,192,106.668,192z M106.668,128c-11.782,0-21.333,9.551-21.333,21.333 s9.551,21.333,21.333,21.333s21.333-9.551,21.333-21.333S118.45,128,106.668,128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M149.335,128h-42.667c-5.891,0-10.667-4.776-10.667-10.667s4.776-10.667,10.667-10.667h42.667 c5.891,0,10.667,4.776,10.667,10.667S155.226,128,149.335,128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M106.668,277.333c-26.342,3.08-50.193-15.778-53.273-42.12c-0.021-0.182-0.042-0.364-0.061-0.546 c0-19.947,18.944-33.408,56.363-40.149c-1.999-4.107-3.035-8.616-3.029-13.184c0-5.891,4.776-10.667,10.667-10.667 c5.891,0,10.667,4.776,10.667,10.667c0,4.843,4.416,9.429,11.669,16.448c11.754,8.809,19.159,22.243,20.331,36.885 C160.001,272.171,134.401,277.333,106.668,277.333z M125.441,213.717c-37.376,4.715-50.773,14.144-50.773,20.949 c0,4.267,5.696,21.333,32,21.333c30.571,0,32-7.317,32-21.333C138.668,227.2,133.697,221.717,125.441,213.717z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F44336"
    },
    d: "M384.001,0C319.234,0.082,266.75,52.566,266.668,117.333c0.035,6.445,0.671,12.873,1.899,19.2 c2.571,16.539,8.739,32.312,18.069,46.208c4.949,8.533,10.667,17.408,16.704,26.88c34.686,49.795,58.598,106.281,70.208,165.845 c1.172,5.773,6.803,9.503,12.576,8.331c4.198-0.852,7.478-4.133,8.331-8.331c11.6-59.57,35.506-116.063,70.187-165.867 c6.08-9.451,11.755-18.261,16.277-26.176c9.505-14.025,15.811-29.967,18.475-46.699c1.246-6.39,1.896-12.882,1.941-19.392 C501.252,52.566,448.769,0.082,384.001,0z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C62828"
    },
    cx: 384.001,
    cy: 117.333,
    r: 53.333
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmaps);
export default __webpack_public_path__ + "static/media/gmaps.a936e50b0befd170d2e60f8278550dd1.svg";
export { ForwardRef as ReactComponent };